const initialState = {
  tasks: [],
  permissionFlags: null,
  taskDetail: null,
  collections: [],
  emailTemplates: [],
  externalApis: [],
  createSchedulePending: false,
  createScheduleError: null,
  listSchedulePending: false,
  listScheduleError: null,
  updateSchedulePending: false,
  updateScheduleError: null,
  deleteSchedulePending: false,
  deleteScheduleError: null,
  loadTaskDetailPending: false,
  loadTaskDetailError: null,
  loadEmailTemplatesPending: false,
  loadEmailTemplatesError: null,
  loadCollectionInSchedulePending: false,
  loadCollectionInScheduleError: null,
  loadExternalApisInSchedulePending: false,
  loadExternalApisInScheduleError: null,
  changeTaskDetailPending: false,
  changeTaskDetailError: null,
  resumeSchedulePending: false,
  resumeScheduleError: null,
  pauseSchedulePending: false,
  pauseScheduleError: null,
  getPermissionFlagsPending: false,
  getPermissionFlagsError: null,
};

export default initialState;
